export class CustomerModel {
  customerId!: number;
  customerName!: string;
  smsCustomerName!: string;
  primaryMobileNo!: string;
  secondaryMobileNo?: string;
  address!: string;
  city!: string;
  pincode!: number;
  emailId?: string;
  customerGstNo?: string;
  isActive!: 'YES' | 'NO';

  constructor(init?: Partial<CustomerModel>) {
    Object.assign(this, init);
  }
}